export default __webpack_public_path__ + "static/media/Team.90048088.png";